import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from '@angular/core';
import {TokenService} from '../../auth/services/token-service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const accessToken = tokenService.getAccessToken();
  const s3request = req.url.includes('digitaloceanspaces.com');
  if (!s3request && accessToken) {
    req = req.clone({setHeaders: {'Authorization': `Bearer ${accessToken}`}});
  }
  return next(req);
};
